import React from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import { Check, X, Circle } from 'lucide-react';

export interface ChecklistItem {
    id: string;
    label: string;
    completed: boolean;
    error?: boolean;
}

interface ConfigurationChecklistProps {
    items: ChecklistItem[];
}

/**
 * Configuration Checklist Component
 * Visual checklist showing configuration progress
 */
const ConfigurationChecklist: React.FC<ConfigurationChecklistProps> = ({ items }) => {
    const getIcon = (item: ChecklistItem) => {
        if (item.error) {
            return <X size={18} className="text-danger" />;
        }
        if (item.completed) {
            return <Check size={18} className="text-success" />;
        }
        return <Circle size={18} className="text-muted" />;
    };

    const getTextClass = (item: ChecklistItem) => {
        if (item.error) return 'text-danger';
        if (item.completed) return 'text-success fw-medium';
        return 'text-muted';
    };

    return (
        <Card className="mt-4">
            <Card.Header>
                <h6 className="mb-0">✓ Checklist de Configuração</h6>
            </Card.Header>
            <Card.Body className="p-0">
                <ListGroup variant="flush">
                    {items.map((item) => (
                        <ListGroup.Item
                            key={item.id}
                            className="d-flex align-items-center gap-3 py-3"
                        >
                            <div className="flex-shrink-0">
                                {getIcon(item)}
                            </div>
                            <span className={getTextClass(item)}>
                                {item.label}
                            </span>
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            </Card.Body>
        </Card>
    );
};

export default ConfigurationChecklist;
